import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaHome, FaCalendarAlt, FaUserFriends, FaCog, FaBell, FaSignOutAlt } from 'react-icons/fa';
import logo from '../assets/logo.svg';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [notifications, setNotifications] = useState(3);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 100, damping: 20 }}
      className={`fixed top-0 left-0 right-0 z-50 ${
        scrolled 
          ? 'bg-white shadow-md text-gray-800' 
          : 'bg-transparent text-white'
      } transition-all duration-300`}
    >
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="Home des Prés" className="h-10 w-10" />
          <motion.h1 
            className="text-xl md:text-2xl font-semibold"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            Home des Prés
          </motion.h1>
        </div>

        <nav className="hidden md:flex items-center space-x-6">
          {[
            { icon: <FaHome className="mr-1" />, label: 'Accueil' },
            { icon: <FaCalendarAlt className="mr-1" />, label: 'Réservations' },
            { icon: <FaUserFriends className="mr-1" />, label: 'Enfants' },
            { icon: <FaCog className="mr-1" />, label: 'Paramètres' }
          ].map((item, index) => (
            <motion.a
              key={index}
              href="#"
              className="flex items-center hover:text-blue-300 transition-colors duration-200"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * index }}
            >
              {item.icon}
              <span>{item.label}</span>
            </motion.a>
          ))}
        </nav>

        <div className="flex items-center space-x-4">
          <motion.div 
            className="relative"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FaBell className={`text-xl ${scrolled ? 'text-gray-700' : 'text-white'}`} />
            {notifications > 0 && (
              <motion.span 
                className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: 'spring', stiffness: 500, damping: 15 }}
              >
                {notifications}
              </motion.span>
            )}
          </motion.div>
          
          <motion.div 
            className="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-sm font-semibold"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            AD
          </motion.div>

          <motion.button
            className="md:flex items-center hidden text-sm font-medium"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaSignOutAlt className="mr-1" />
            <span>Déconnexion</span>
          </motion.button>
        </div>

        {/* Menu mobile */}
        <button className="md:hidden text-2xl">
          ☰
        </button>
      </div>
    </motion.header>
  );
};

export default Header;
